export default __webpack_public_path__ + "static/media/developer-flat.b5638fdd.gif";